export const SNOWPLOW_EVENT_SCHEMA = 'iglu:com.vooglam/event/jsonschema/1-0-0';
export const SNOWPLOW_PUBLIC_PROPERTIES_SCHEMA =
  'iglu:com.vooglam/public_properties/jsonschema/1-0-0';

export type SnowplowEventParams = Record<string, unknown>;

export type SnowplowRuntimePublicConfig = Record<string, unknown> & {
  NODE_ENV?: string;
  VUE_APP_MODE?: string;
  VUE_APP_ENABLE_SNOWPLOW?: boolean | string | number;
  VUE_APP_ENABLE_SNOWPLOW_ERROR_TRACKING?: boolean | string | number;
  VUE_APP_ENABLE_SNOWPLOW_GZIP?: boolean | string | number;
  VUE_APP_SNOWPLOW_COLLECTOR_URL?: string;
  VUE_APP_SNOWPLOW_POST_PATH?: string;
  VUE_APP_SNOWPLOW_APP_ID?: string;
  VUE_APP_SNOWPLOW_ENV?: string;
};

export type SnowplowSgtmPixelConfig = Record<string, unknown> & {
  snowplow?: boolean;
};

export type SnowplowInitInput = {
  runtimePublic: SnowplowRuntimePublicConfig;
  sgtmPixelConfig?: SnowplowSgtmPixelConfig | null;
};

export type SnowplowResolvedConfig = {
  enabled: boolean;
  configuredEnabled: boolean;
  collectorUrl: string;
  postPath: string;
  appId: string;
  env: string;
  gzipEnabled: boolean;
  errorTrackingEnabled: boolean;
  debugEnabled: boolean;
  disabledReason: string;
};

export type SnowplowSelfDescribingJson = {
  schema: string;
  data: SnowplowEventParams;
};

export type SnowplowQueuedEvent = {
  eventName: string;
  params: SnowplowEventParams;
};

export type SnowplowDebugState = {
  enabled: boolean;
  initialized: boolean;
  queueLength: number;
  collectorUrl: string;
  postPath: string;
  gzipEnabled: boolean;
  errorTrackingEnabled: boolean;
  disabledReason: string;
};
